import getRequest from "../../getRequest";
/**
 * Pings cloud functions for password override so they are spun up and responsive
 * @param {string} role Specifies role of user whose password is being overridden
 * @returns {promise}
 */
export default function pingPasswordFunc (role) {
  const EDUCATOR_BASE_URL = `https://us-central1-bellwork-cg1.cloudfunctions.net/manualAddEducator`
  const STUDENT_BASE_URL = `https://us-central1-bellwork-cg1.cloudfunctions.net/manualAddStudent`
  const DUP_BASE_URL = `https://us-central1-bellwork-cg1.cloudfunctions.net/checkDuplication`
  const PING_QUERY = `?ping=true`
  const pingPassword = (
    role === 'Student'
    ? `${STUDENT_BASE_URL}${PING_QUERY}`
    : `${EDUCATOR_BASE_URL}${PING_QUERY}`
  )
  const pingDup = `${DUP_BASE_URL}${PING_QUERY}`
  const p1 = getRequest(pingPassword)
  const p2 = getRequest(pingDup)
  return Promise.all([p1, p2])
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/pingPasswordFunc.js